import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { i18n } from '@/base/helpers';

import './index.css';
import { Overlay, RedeemModalHeader } from '../../components';

export default function Redeem({ isOpen, onClose, title, message, status, coupon }) {
  return (
    <Overlay isOpen={isOpen}>
      <div className="beans-normalize liana-redeem-modal">
        <RedeemModalHeader headerTitle={title} onClose={onClose} />

        <RedeemInfo status={status} message={message} coupon={coupon} />
      </div>
    </Overlay>
  );
}

const RedeemInfo = ({ status, message, coupon }) => {
  const [isCopied, setIsCopied] = useState(false);
  const onCopy = () => {
    setIsCopied(true);
    window.Beans3._utils.copyToClipboard(coupon.uid);
    setTimeout(() => setIsCopied(false), 2000);
  };
  return (
    <Fragment>
      <div className="liana-redeem-popup-message  liana-text-sm">{message}</div>
      {status === 'done' && (
        <div className=" liana-text-base">
          <div className="liana-redeem-popup-button outlined" onClick={() => onCopy()}>
            {isCopied ? i18n.t('button', 'copied') : i18n.t('button', 'copy_coupon')}
          </div>
          <div
            className="liana-redeem-popup-button plain"
            onClick={() => (window.location = `/checkout?discount=${coupon.uid}`)}
          >
            {i18n.t('button', 'apply_discount_and_checkout')}
          </div>
        </div>
      )}
    </Fragment>
  );
};
